export default __webpack_public_path__ + "static/media/mdi_plane-car.25639cec.svg";